import React from 'react';
import { PropTypes } from 'prop-types';

import GalleryContent from '../GalleryContent';
import TestimonialContent from '../TestimonialContent';
import ServicesContent from '../ServicesContent';
import ProcessContent from '../ProcessContent';
import WorkshopProcessContent from '../WorkshopProcessContent';
import { CarouselTypes } from '../consts';

import CaseStudiesContent from '../CaseStudiesContent';

const CarouselContent = ({
    slides,
    width,
    isMoving,
    transitionDuration,
    translate,
    moveToNextSlide,
    moveToNextSlideMobile,
    activeIndex,
    type,
    moveToSlideId,
    title,
    galleryType,
    handleHover,
    titleAs,
    subtitleAs,
    withButtons,
}) => {
    switch (type) {
        case CarouselTypes.GALLERY:
            return (
                <GalleryContent
                    translate={translate}
                    transitionDuration={transitionDuration}
                    type={type}
                    width={width}
                    slides={slides}
                    activeIndex={activeIndex}
                    moveToNextSlide={moveToNextSlide}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    moveToSlideId={moveToSlideId}
                    galleryType={galleryType}
                    withButtons={withButtons}
                />
            );

        case CarouselTypes.TESTIMONIALS:
            return (
                <TestimonialContent
                    translate={translate}
                    transitionDuration={transitionDuration}
                    type={type}
                    width={width}
                    slides={slides}
                    activeIndex={activeIndex}
                    moveToNextSlide={moveToNextSlide}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    handleHover={handleHover}
                    moveToSlideId={moveToSlideId}
                />
            );

        case CarouselTypes.TESTIMONIALS_CLUTCH:
            return (
                <TestimonialContent
                    showClutch
                    handleHover={handleHover}
                    translate={translate}
                    transitionDuration={transitionDuration}
                    type={type}
                    width={width}
                    slides={slides}
                    activeIndex={activeIndex}
                    moveToNextSlide={moveToNextSlide}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    moveToSlideId={moveToSlideId}
                    showSectionTitle
                />
            );

        case CarouselTypes.CASE_STUDIES:
            return (
                <CaseStudiesContent
                    type={type}
                    slides={slides}
                    activeIndex={activeIndex}
                    moveToNextSlide={moveToNextSlide}
                    width={width}
                    transitionDuration={transitionDuration}
                    isMoving={isMoving}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    moveToSlideId={moveToSlideId}
                    translate={translate}
                />
            );
        case CarouselTypes.SERVICES:
            return (
                <ServicesContent
                    width={width}
                    slides={slides}
                    transitionDuration={transitionDuration}
                    translate={translate}
                    activeIndex={activeIndex}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    moveToSlideId={moveToSlideId}
                    handleHover={handleHover}
                    title={title}
                    titleAs={titleAs}
                    subtitleAs={subtitleAs}
                />
            );
        case CarouselTypes.PROCESS:
            return (
                <ProcessContent
                    width={width}
                    slides={slides}
                    transitionDuration={transitionDuration}
                    translate={translate}
                    activeIndex={activeIndex}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    moveToNextSlide={moveToNextSlide}
                    moveToSlideId={moveToSlideId}
                    title={title}
                />
            );
        case CarouselTypes.WORKSHOP_PROCESS:
            return (
                <WorkshopProcessContent
                    width={width}
                    slides={slides}
                    transitionDuration={transitionDuration}
                    translate={translate}
                    activeIndex={activeIndex}
                    moveToNextSlideMobile={moveToNextSlideMobile}
                    moveToNextSlide={moveToNextSlide}
                    moveToSlideId={moveToSlideId}
                    title={title}
                    type={type}
                    isMoving={isMoving}
                />
            );
        default:
            return <span>Please provide carousel type</span>;
    }
};

CarouselContent.propTypes = {
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    width: PropTypes.number.isRequired,
    transitionDuration: PropTypes.number.isRequired,
    translate: PropTypes.number.isRequired,
    isMoving: PropTypes.bool.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    moveToNextSlideMobile: PropTypes.func.isRequired,
    activeIndex: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    moveToSlideId: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
    galleryType: PropTypes.string.isRequired,
    handleHover: PropTypes.func,
    titleAs: PropTypes.string,
    subtitleAs: PropTypes.string,
    withButtons: PropTypes.bool.isRequired,
};

CarouselContent.defaultProps = {
    title: null,
    handleHover: null,
    titleAs: undefined,
    subtitleAs: undefined,
};

export default CarouselContent;
